export enum AuthCacheTag {
  AUTH_DATA = 'authData',
}

export enum TenantFeatures {
  ENDUSER_WEB_APP = 'enduser-web-app',
  MEMBERSHIP_CARDS = 'users:membership-cards',
  BOOKING_HUB = 'booking-hub',
  ON_DEMAND = 'on-demand',
}
